import { useEffect, useRef } from "react";

// The preview animates the phone's scan line up and down and pops the
// "Joined" badge in once. Driven with the Web Animations API so no global
// keyframes are needed; skipped entirely when the visitor prefers reduced
// motion (the scene then shows its resting state).
export function useQrSceneMotion() {
  const scanRef = useRef<HTMLSpanElement>(null);
  const badgeRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const startMotion = () => {
      const reduce = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;
      const scan = scanRef.current;
      const badge = badgeRef.current;
      if (reduce || !scan || !badge) return [];
      return [
        scan.animate(
          // Sweep from the top to the bottom of the scan frame.
          [
            { transform: "translateY(0)" },
            {
              transform: `translateY(${(scan.parentElement?.clientHeight ?? 0) - 20}px)`,
            },
          ],
          {
            duration: 1600,
            easing: "ease-in-out",
            iterations: Infinity,
            direction: "alternate",
          },
        ),
        badge.animate(
          [
            { opacity: 0, transform: "scale(0.6)" },
            { opacity: 1, transform: "none" },
          ],
          { duration: 500, delay: 1200, fill: "both" },
        ),
      ];
    };
    const animations = startMotion();
    return () => animations.forEach((animation) => animation.cancel());
  }, []);

  return { scanRef, badgeRef };
}
